(function(angular){
    'use strict';

    angular.module('onvio.setup.migrations').controller('onvio.setup.migrations.MigrationSetupController', migrationSetup);
    migrationSetup.$inject = ['$scope', 'migrationConfig'];

    function migrationSetup($scope, migrationConfig) {
        /*jshint validthis:true */
        var vm = this;

        vm.migrationConfig = migrationConfig;
        vm.tabDeselect = tabDeselect;
        vm.hasUnsavedData = false;

        $scope.noUtilityAppsInstalled = function() {
            if(angular.isUndefined(migrationConfig) || angular.isUndefined(migrationConfig.installedProducts) ||
                migrationConfig.installedProducts === null ) {
                return true;
            }
            return false;
        };

        $scope.hasDesktopUtility = function(product) {
            if( $scope.noUtilityAppsInstalled ) {
                return false;
            }
            for(var i; i < migrationConfig.installedProducts.length; i++) {
                var item = migrationConfig.installedProducts[i];
                if( product === item.product) {
                    return true;
                }
            }
            return false;
        };

        function tabDeselect(whichTab) {
            if(whichTab === 'fileCabinet') {
                //vm.setThemeDirty();
            }
        }
    }
})(window.angular);
